module.exports = __webpack_public_path__ + "static/media/augtel-background.e4490eba.jpg";